import {Injectable} from '@angular/core';
import {RequestExecutor} from '../../../util/request-executor';

@Injectable()
export class DeviationDefinitionListResolver {
  constructor(private request: RequestExecutor) {
  }

  resolve(): Promise<any> {
    return this.request.get('/deviation/definition', {});
  }
}
